module.exports = __webpack_public_path__ + "images/0ccb722182186e588e772ca71dc5b353286523ab2b1aadc029504f4bd81bd4f1.svg";